import { ExamInput, Scalars } from '@generated/base-types';
import { ExamProvisionSettings } from '@new/common/modal/exam-provision-modal/exam-provision-modal.component';
import { ManagerError } from '@new/common/utils/error-parser';
import { Exam, LockState } from '../../../lib/types';

/* Query actions */

export class LoadExams {
  public static readonly type = '[Exams] Load';
}

export class LoadExamsSuccess {
  public static readonly type = '[Exams] Load success';
  constructor(public readonly exams: Exam[]) {}
}

export class LoadExamsFailure {
  public static readonly type = '[Exams] Load failure';
  constructor(public readonly error: ManagerError) {}
}

export class SetSelectedExamIds {
  public static readonly type = '[Exams] Set selected IDs';
  constructor(public readonly ids: string[]) {}
}

/* Mutation actions */

export class Failure {
  public static readonly type = '[Exams] Mutation failure';
  constructor(
    public readonly error: ManagerError,
    public readonly validationMessage?: string
  ) {}
}

export class CreateExam {
  public static readonly type = '[Exams] Create';
  constructor(public readonly examInput: ExamInput) {}
}

export class CreateExamSuccess {
  public static readonly type = '[Exams] Create success';
  constructor(public readonly exam: Exam) {}
}

export class UpdateExam {
  public static readonly type = '[Exams] Update';
  constructor(
    public readonly examId: Scalars['ID'],
    public readonly examInput: ExamInput
  ) {}
}

export class UpdateExamSuccess {
  public static readonly type = '[Exams] Update success';
  constructor(
    public readonly exam: Exam,
    public readonly lockState?: LockState
  ) {}
}

export class DeleteExam {
  public static readonly type = '[Exams] Delete';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class DeleteExamSuccess {
  public static readonly type = '[Exams] Delete success';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class LockExam {
  public static readonly type = '[Exams] Lock';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class UnlockExam {
  public static readonly type = '[Exams] Unlock';
  constructor(
    public readonly examId: Scalars['ID'],
    public readonly unlockCode?: string
  ) {}
}

export class PublishExamAsSelfAssessment {
  public static readonly type = '[Exams] Publish as self-assessment';
  constructor(
    public readonly examId: Scalars['ID'],
    public readonly password?: string
  ) {}
}

export class PublishExamAsSelfAssessmentSuccess {
  public static readonly type = '[Exams] Publish as self-assessment success';
  constructor(public readonly examId: Scalars['ID']) {}
}

export class SendExamToMeasured {
  public static readonly type = '[Exams] Send to Measured';
  constructor(
    public readonly examId: Scalars['ID'],
    public readonly provisionSettings: ExamProvisionSettings
  ) {}
}

export class SendExamToMeasuredSuccess {
  public static readonly type = '[Exams] Send to Measured success';
  constructor(public readonly examId: Scalars['ID']) {}
}
